export const marketingKo = {
  // FreeMagnetPage
  'marketing.free.seo.title': '무료 빠른시작판',
  'marketing.free.seo.description':
    'Grymwyrd 무료 빠른시작판을 다운로드하세요 — 규칙서와 오늘 밤 바로 플레이할 수 있는 원회차 어드벤처. Twilight에 들어가세요.',
  'marketing.free.eyebrow': '당신의 무료 여정',
  'marketing.free.heading': 'Twilight에 들어가세요 — 무료로',
  'marketing.free.subheadLead': '',
  'marketing.free.quickstartName': 'Grymwyrd 빠른시작판',
  'marketing.free.subheadTail':
    '— 핵심 규칙과 오늘 밤 플레이할 수 있는 원회차 어드벤처. 어디로 보낼지 알려주세요.',
  'marketing.free.benefit.rules.title': '규칙서',
  'marketing.free.benefit.rules.body': '플레이에 필요한 모든 것을 빠른시작판에 담았습니다.',
  'marketing.free.benefit.oneShot.title': '원회차 어드벤처',
  'marketing.free.benefit.oneShot.body': '첫 밤을 위한 준비된 공포 모험.',
  'marketing.free.benefit.livingWorld.title': '살아 숨 쉬는 세계',
  'marketing.free.benefit.livingWorld.body': '백과사전, 지도, 매주 업데이트와 연결됩니다.',
  'marketing.free.playInstead.heading': '그냥 플레이하고 싶으신가요?',
  'marketing.free.playInstead.body':
    '첫 캐릭터를 만들고 10분 솔로 체험판을 시작하세요 — 구매 없이, 약정 없이.',
  'marketing.free.playInstead.cta': '캐릭터 만들기',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': '문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
  'marketing.leadForm.ready': '무료 빠른시작판이 준비되었습니다.',
  'marketing.leadForm.downloadCta': '빠른시작판 다운로드',
  'marketing.leadForm.alsoEmailed': '받은편지함으로도 링크를 보냈습니다.',
  'marketing.leadForm.checkInbox': '받은편지함을 확인하세요 — 무료 빠른시작판이 곧 도착합니다.',
  'marketing.leadForm.emailPlaceholder': 'you@example.com',
  'marketing.leadForm.emailAriaLabel': '이메일 주소',
  'marketing.leadForm.defaultCta': '빠른시작판을 보내주세요',
  'marketing.leadForm.privacyNote':
    '스팸 없음 — 빠른시작판과 가끔의 세계관 정보만 보냅니다. 언제든 구독 해제할 수 있습니다.',
}
